import React, { useState, useEffect } from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "./LoanTable.scss";
import Arrow from "../../images/arrow-right-purple.svg";
import { useSelector, useDispatch } from "react-redux";
import BaseCustomerTable from "../BaseCustomerTable/BaseCustomerTable";
import LoanDetailModal from "./LoanDetailModal";

export default function LoanTable({ tableData, fakeData }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [sorting, setSorting] = useState({
    column: "",
    direction: "asc",
  });
  const [selectedData, setSelectedData] = useState([]);
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  const handleSort = (columnName) => {
    const isAsc = sorting.column === columnName && sorting.direction === "asc";
    setSorting({
      column: columnName,
      direction: isAsc ? "desc" : "asc",
    });
  };

  const sortedData = [...fakeData].sort((a, b) => {
    if (!sorting.column) return 0;

    let aValue = a[sorting.column];
    let bValue = b[sorting.column];

    if (sorting.column === "amount" || sorting.column === "amountDue") {
      aValue = Number(aValue.replace(/[^0-9.-]+/g, ""));
      bValue = Number(bValue.replace(/[^0-9.-]+/g, ""));
    }

    if (sorting.column === "dueDate") {
      aValue = new Date(aValue);
      bValue = new Date(bValue);
    }

    const isAsc = sorting.direction === "asc";
    if (aValue < bValue) {
      return isAsc ? -1 : 1;
    }
    if (aValue > bValue) {
      return isAsc ? 1 : -1;
    }
    return 0;
  });

  const dispatch = useDispatch();

  const tableDataRedux = useSelector(
    (state) => state.accountingTable.accountingTable
  );

  const accountingDataStateFilter = useSelector(
    (state) => state.accountingTable.accountingTableFilter
  );

  const pageCount = fakeData ? Math.ceil(fakeData.length / rowsPerPage) : 0;
  const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleOpen = (subAccounts) => {
    setOpen(true);
    setSelectedData([subAccounts]);
  };

  useEffect(() => {
    return () => {
      setSorting({
        column: "",
        direction: "asc",
      });
    };
  }, []);

  function displayName(row) {
    if (row.vacctstructure.piidname) {
      return row.vacctstructure.piidname;
    } else if (row.vacctstructure.businessname) {
      return row.vacctstructure.businessname;
    } else {
      return `${row.vacctstructure.firstName} ${row.vacctstructure.lastName}`;
    }
  }

  return (
    <>
      <LoanDetailModal
        open={open}
        handleClose={handleClose}
        selectedData={selectedData}
      />
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
          <TableHead>
            <TableRow>
              <TableCell
                align="left"
                className="transaction-table-headers"
                onClick={() => handleSort("nameOfUser")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Name Of User</p>
                  {sorting.column === "nameOfUser" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
              <TableCell
                align="left"
                className="transaction-table-headers"
                onClick={() => handleSort("loanType")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Loan Type</p>
                  {sorting.column === "loanType" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
              {/* <TableCell
              //onClick={() => handleSortClick("date")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Account ID</p>
                  {sorting.column === "date" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell> */}
              <TableCell
                align="left"
                className="transaction-table-headers"
                onClick={() => handleSort("amount")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Amount</p>
                  {sorting.column === "amount" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>

              <TableCell
                align="left"
                className="transaction-table-headers"
                onClick={() => handleSort("amountDue")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Amount Due</p>
                  {sorting.column === "amountDue" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>

              <TableCell
                align="center"
                className="transaction-table-headers"
                onClick={() => handleSort("dueDate")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Due Date</p>
                  {sorting.column === "dueDate" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
              <TableCell
                align="center"
                className="transaction-table-headers"
                onClick={() => handleSort("scoring")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Scoring</p>
                  {sorting.column === "scoring" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
              <TableCell className="transaction-table-headers " align="right">
                <div className="header-cell-content justify-content-end">
                  <p className="transaction-table-headers">Details</p>
                  {sorting.column === "amount" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <React.Fragment key={index}>
                  <TableRow>
                    <TableCell style={{ width: 200 }} align="left">
                      <p className="transaction-table-date">{row.nameOfUser}</p>
                    </TableCell>
                    <TableCell style={{ width: 200 }} align="left">
                      <p className="transaction-table-date">{row.loanType}</p>
                    </TableCell>

                    <TableCell style={{ width: 300 }} align="left">
                      <div className="transaction-table-address-container">
                        <p className="transaction-table-date ">{row.amount}</p>
                      </div>
                    </TableCell>

                    <TableCell style={{ width: 200 }} align="left">
                      <p className="transaction-table-date">{row.amountDue}</p>
                    </TableCell>

                    <TableCell style={{ width: 200 }} align="left">
                      <p className="transaction-table-date ">{row.dueDate}</p>
                    </TableCell>
                    <TableCell style={{ width: 200 }} align="left">
                      <p className="transaction-table-date ">{row.scoring}</p>
                    </TableCell>
                    <TableCell style={{ width: 400 }} align="right">
                      <div className="d-flex justify-content-end align-items-center details-container">
                        {/* <a
                          target="_blank"
                          aria-label="Chat on WhatsApp"
                          href="https://wa.me/14169899999"
                        >
                          <WhatsAppIcon sx={{ color: "#25d366" }} />
                        </a>

                        <Message sx={{ color: "grey" }} /> */}
                        <div
                          className="d-flex justify-content-end"
                          onClick={() => handleOpen(row)}
                          style={{ cursor: "pointer" }}
                        >
                          <p className="transaction-table-date">View</p>
                          <img src={Arrow} alt="View Details" />
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
        <BaseCustomerTable
          page={page}
          onPageChange={handleChangePage}
          pageNumbers={pageNumbers}
        />
      </TableContainer>
    </>
  );
}
